import { Component, OnInit, Input } from '@angular/core';
import { ProductUnit } from '@core/services/data.service';

@Component({
  selector: 'product-unit',
  templateUrl: './product-unit.component.html',
  styleUrls: ['./product-unit.component.scss']
})
export class ProductUnitComponent implements OnInit {

  @Input()
  public type: ProductUnit = ProductUnit.Unknown;

  public get name(): string {
    switch (this.type) {      
      case ProductUnit.Meter: return 'm';
      case ProductUnit.Kilogram: return 'kg';
      default: return 'na';       
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
